import * as types from "../constants/actionConstants";

const initialState = {
    versionNote: [],
    allNotes: []
};

function notesReducer(state = initialState, action) {
    switch(action.type) {
        case types.QUESTIONNAIRE_NOTES_GET_SUCCESS:
            return {versionNote: action.list, allNotes: []};

        case types.QUESTIONNAIRE_ALL_NOTES_GET_SUCCESS:
            return {versionNote: [], allNotes: action.list};

        default:
            return state;
    }
}

export default notesReducer;
